import moment from "moment";
import { useEffect, useState } from "react";

const Calendar = ({ data, date }) => {
    const [currentMonth, setCurrentMonth] = useState(moment(date));
    const [calendarData, setCalendarData] = useState([]);

    useEffect(() => {
        setCurrentMonth(moment(date));
    }, [date]);

    const generateCalendar = (data) => {
        const startMonth = currentMonth.clone().startOf("month");
        const startCalendar = startMonth.clone().startOf("isoWeek");

        const dataMap = new Map(data.map((d) => [moment(d.sdate).format("YYYY-MM-DD"), d.value]));

        let days = [];
        for (let i = 0; i < 42; i++) {
            let day = startCalendar.clone().add(i, "days");
            let formattedDate = day.format("YYYY-MM-DD");
            days.push({
                date: day,
                value: dataMap.get(formattedDate) || ""
            });
        }
        setCalendarData(days);
    };

    const prevMonth = () => {
        setCurrentMonth((prev) => prev.clone().subtract(1, "month"));
    };

    const nextMonth = () => {
        setCurrentMonth((prev) => prev.clone().add(1, "month"));
    };

    useEffect(() => {
        generateCalendar(data);
        // eslint-disable-next-line
    }, [currentMonth, data]);

    return (
        <table className="calendar-table">
            <thead>
                <tr>
                    <th onClick={prevMonth}>
                        <i className="icon icon-prev" />
                    </th>
                    <th colSpan={5} id="monthYear">
                        {currentMonth.format("YYYY년 MM월")}
                    </th>
                    <th onClick={nextMonth}>
                        <i className="icon icon-next" />
                    </th>
                </tr>
                <tr>
                    <td>월</td>
                    <td>화</td>
                    <td>수</td>
                    <td>목</td>
                    <td>금</td>
                    <td>토</td>
                    <td>일</td>
                </tr>
            </thead>
            <tbody id="calendar-body">
                {Array.from({ length: 6 }).map((_, weekIdx) => (
                    <tr key={weekIdx}>
                        {calendarData.slice(weekIdx * 7, (weekIdx + 1) * 7).map((day, dayIdx) => (
                            <td key={dayIdx}>
                                <span>{day.date.format("D")}</span>
                                <p>{day.value}</p>
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Calendar;
